exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#edit__project__modal.duplicate-preview[data-v-3221541e]{padding-top:0!important}.duplicate-preview .project--top--section[data-v-3221541e]{margin-top:0}.duplicate-field-row[data-v-3221541e]{display:flex;align-items:flex-start;margin-bottom:4px}.duplicate-checkbox[data-v-3221541e]{margin-right:8px;margin-top:2px;flex-shrink:0;z-index:1}.duplicate-field-content[data-v-3221541e]{flex:1;min-width:0}.select-all-checkbox[data-v-3221541e]{font-size:13px}.duplicate-preview .field-box[data-v-3221541e]{margin-bottom:0}", ""]);

// exports
